import { Chip } from "@mui/material";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import * as React from "react";
import utils from "src/assets/utils/utils";

function Row(props) {
  const { row } = props;
  return (
    <React.Fragment>
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        <TableCell align="left">
          {utils.formatTimestamp(row?.timestamp)}
        </TableCell>
        <TableCell align="left">
          <h5>T/N Id:&nbsp;&nbsp;{row?._id}</h5>

          <h5>Lead:&nbsp;&nbsp;{row?.lead?._id || "-"}</h5>
          <h5>Sub Lead Id:&nbsp;&nbsp;{row?.lead?.sub_lead_id || "-"}</h5>
        </TableCell>
        <TableCell align="left">
          <h4>{row?.user && row?.user?.user_id}</h4>

          <p>{row?.user && row?.user?.name}</p>

          <p>
            Customer:{" "}
            {row?.user &&
              (row?.lead?.parameters?.name || row?.lead?.parameters?.Name)}
          </p>
        </TableCell>
        <TableCell align="left">
          <p>{row?.campaign?.title}</p>
          <h4>{row?.campaign?.status}</h4>
        </TableCell>
        <TableCell align="left">
          {row?.lead?.currentLevel &&
          row?.lead?.levelMeta &&
          row?.lead?.levelMeta.length ? (
            <>
              <p>
                {
                  row?.lead?.levelMeta[(row?.lead?.currentLevel || 1) - 1]
                    ?.title
                }
              </p>
              <p>T/N level: {row?.level}</p>
              <p>lead level: {row?.lead?.currentLevel}</p>
            </>
          ) : (
            "-"
          )}
        </TableCell>
        <TableCell align="left">
          {row?.action?.length &&
            row?.action.map((i) => (
              <Chip
                label={i}
                size={"small"}
                color={i === "due" ? "default" : "info"}
                sx={{ mb: "6px" }}
              />
            ))}
        </TableCell>
        <TableCell align="left"><p>{row?.amount}</p><p>{`Base: ${row.base_amount}`}</p></TableCell>
        <TableCell align="left" width={'12px'}><p>{row?.source}</p></TableCell>
        
        <TableCell align="left">
          {row?.user?.bankAccount && (
            <>
              <p>Name:&nbsp;&nbsp;{row?.user?.bankAccount.account_name}</p>
              <p>A/c No.&nbsp;{row?.user?.bankAccount.account_number}</p>
              <p>IFSC:&nbsp;&nbsp;{row?.user?.bankAccount.ifsc_code}</p>
            </>
          )}
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

export default function TransactionTable({ details }) {
  return (
    <TableContainer component={Paper}>
      <Table aria-label="collapsible table">
        <TableHead>
          <TableRow>
            <TableCell align="left">Date</TableCell>
            <TableCell align="left">Id</TableCell>
            <TableCell align="left">User</TableCell>
            <TableCell align="left">Product</TableCell>
            <TableCell align="left">Level</TableCell>
            <TableCell align="left">Actions</TableCell>
            <TableCell align="left">Amount</TableCell>
            <TableCell align="left">Source</TableCell>
            <TableCell align="left">Bank Account</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {(details &&
            details.length &&
            details.map((row) => <Row key={row.id} row={row} />)) ||
            ""}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
